import React from "react";
import { toast } from "react-toastify";
import { ReactComponent as Bean } from "src/Assets/Icons/coffeeBean.svg";

const showToast = (type, message) => {
  const icons = {
    success: <Bean />,
    warning: <Bean />,
    error: <Bean />,
  };

  toast[type](message, {
    icon: icons[type] || null,
    position: "bottom-center",
  });
};

export default showToast;
